import {CommonActions} from '@react-navigation/native';
import {rootNavigationRef} from './navigation';
import {Screens} from './model';

let pendingEmailConfirmation: {op: string; code: string} | null = null;

const navigateInProfile = (screen: Screens, params?: object) => {
  if (!rootNavigationRef.isReady()) {
    return false;
  }

  rootNavigationRef.dispatch(
    CommonActions.navigate({
      name: Screens.MainTabs,
      params: {
        screen: Screens.Profile,
        params: {screen, params},
      },
    }),
  );

  return true;
};

export const navigateToProfileUserContacts = () => {
  pendingEmailConfirmation = null;
  navigateInProfile(Screens.ProfileUserContacts);
};

export const navigateToProfileEmailConfirmation = (op: string, code: string) => {
  const params = {op, code};

  if (navigateInProfile(Screens.ProfileUserEmailConfirmation, params)) {
    return;
  }

  pendingEmailConfirmation = params;
};

// NavigationContainer onReady — deep link came before the ref is ready.
export const openPendingEmailConfirmation = () => {
  if (!pendingEmailConfirmation) {
    return;
  }

  const params = pendingEmailConfirmation;
  pendingEmailConfirmation = null;
  navigateInProfile(Screens.ProfileUserEmailConfirmation, params);
};
